import { collection, getDocs } from "firebase/firestore";
import { auth, db } from "../firebase";
import { UserType } from "../utils/types";
import { checkUnreadMessages } from "../components/ChatUtil";

export const fetchUsers = async (setUsers: any) => {
  const usersCollection = collection(db, "users");
  const usersSnapshot = await getDocs(usersCollection);
  const usersOrig = usersSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  })) as UserType[];
  const users = shuffleArray(usersOrig);

  if (auth.currentUser) {
    var filteredUsers = await Promise.all(
      users.map(async (x) => {
        return {
          ...x,
          unreadMessages: await checkUnreadMessages(
            x.id,
            auth.currentUser?.uid
          ),
        };
      })
    );
    setUsers(filteredUsers.filter((x) => x.id !== auth.currentUser?.uid));
  } else
    setUsers(
      users.map((x) => {
        return {
          ...x,
          unreadMessages: false,
        };
      })
    );
};

// Fisher-Yates Shuffle Algorithm
export const shuffleArray = (array: any[]) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};
